import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ITaskComment, ITaskCommentFilter } from "./task-comment.interface";
import * as _ from 'lodash';
import { HttpService } from "../../../../../http.service";
import { UtilsService } from "../../../../shared/services/utils.service";
import { AuthService } from "../../../../shared/services/auth.service";
import { apiURL, EnvConfig } from "../../../../../env-config";

let self: TaskCommentService;

@Injectable()
export class TaskCommentService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService
  ) {
    self = this;
  }

  getComments(filter?: ITaskCommentFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_TASKS_COMMENTS)}${queryParams}`);
  }

  getCommentsCount(filter?: ITaskCommentFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_TASKS_COMMENTS)}/count${queryParams}`);
  }

  getComment(comment: ITaskComment | string): Observable<any> {
    let id = (typeof comment == 'string') ? comment : comment._id;
    return this._http.get(`${apiURL(EnvConfig.API_TASKS_COMMENTS)}/${id}`);
  }

  createComment(task: ITaskComment): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_TASKS_COMMENTS)}`, task);
  }

  updateComment(task: ITaskComment): Observable<any> {
    let id = task._id;
    delete task._id;
    return this._http.patch(`${apiURL(EnvConfig.API_TASKS_COMMENTS)}/${id}`, task);
  }

  deleteComment(task: ITaskComment | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof task == 'string') ? task : task._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_TASKS_COMMENTS)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_TASKS_COMMENTS)}/${id}/delete`);
  }

  restoreComment(task: ITaskComment | string): Observable<void> {
    let id = (typeof task == 'string') ? task : task._id;
    return this._http.post(`${apiURL(EnvConfig.API_TASKS_COMMENTS)}/${id}/restore`, null);
  }

  exportTaskComments(query: any) {
    query.company = this._AuthService.companyId();
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    this._http.get(`${apiURL(EnvConfig.API_TASKS_COMMENTS)}/export${queryParams}`, { responseType: "arraybuffer" }).subscribe(file => {
      this._utilsService.blobToFile(file, "application/xlsx", 'reporte-comentarios-' + new Date().getTime() + '.xlsx');
    });
  }
}